import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'
import { getCurrentGaPageName } from '@/lib/utils'
import type { TabbedFlowSectionContent } from '@/components/TabbedFlowSteps.vue'

// Base interface for shared properties
interface BasePageContent {
	flowContent: TabbedFlowSectionContent
}

// Shared utility functions for both shipping and shopping components
export const getFlowIcons = (theme: 'shopping' | 'shipping' = 'shipping') => ({
	tab_1: [
		'flow_collect_parcel',
		'flow_contact_us',
		'flow_request_received',
		'flow_approved',
	],
	tab_2:
		theme === 'shopping'
			? [
					'flow_contact_us',
					'flow_ship_return',
					'flow_return_to_seller',
					'flow_approved',
			  ]
			: [
					'flow_contact_us',
					'flow_shipping_label',
					'flow_ship_return',
					'flow_return_to_seller',
			  ],
})

export const createFlowHandlers = (pageContent: BasePageContent) => {
	const handleButtonClick = () => {
		const url = pageContent.flowContent.buttonLink
		if (url) {
			window.location.href = url
		}

		createGAEvent(GaGeneralEvent.ButtonClick, {
			page_name: getCurrentGaPageName(),
			button_name: 'Get Help - Step',
		})
	}

	const handleTabClick = (index: number) => {
		const buttonNames = ['Lost or Damaged - Step', 'Return - Step']
		const buttonName = buttonNames[index]

		createGAEvent(GaGeneralEvent.ButtonClick, {
			page_name: getCurrentGaPageName(),
			button_name: buttonName,
		})
	}

	return { handleButtonClick, handleTabClick }
}
